import api from './api';

export interface FormaPgto {
  id: number;
  codigo: string;
  nome: string;
  descricao?: string;
  icone?: string;
  ativo: boolean;
  is_default?: boolean;
  ordem: number;
  createdAt: string;
  updatedAt: string;
}

export interface FormaPgtoSelect {
  value: string;
  label: string;
  icone?: string;
}

class FormaPgtoService {
  // Buscar formas de pagamento ativas
  async getFormasAtivas(): Promise<FormaPgto[]> {
    try {
      const response = await api.get('/formas-pgto/ativas');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar formas de pagamento ativas:', error);
      return [];
    }
  }

  // Buscar formas de pagamento para select
  async getFormasParaSelect(): Promise<FormaPgtoSelect[]> {
    try {
      const response = await api.get('/formas-pgto/select');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar formas de pagamento para select:', error);
      return [];
    }
  }

  // Buscar forma de pagamento por código
  async getFormaPorCodigo(codigo: string): Promise<FormaPgto | null> {
    try {
      const response = await api.get(`/formas-pgto/codigo/${codigo}`);
      return response.data || null;
    } catch (error) {
      console.error('Erro ao buscar forma de pagamento por código:', error);
      return null;
    }
  }

  // Buscar todas as formas de pagamento (admin)
  async getAllFormas(params?: {
    page?: number;
    limit?: number;
    search?: string;
    ativo?: boolean;
  }): Promise<{
    formas: FormaPgto[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      pages: number;
    };
  }> {
    try {
      const response = await api.get('/formas-pgto', { params });
      return response.data || { formas: [], pagination: { total: 0, page: 1, limit: 10, pages: 0 } };
    } catch (error) {
      console.error('Erro ao buscar formas de pagamento:', error);
      return { formas: [], pagination: { total: 0, page: 1, limit: 10, pages: 0 } };
    }
  }

  // Criar nova forma de pagamento
  async createForma(data: Partial<FormaPgto>): Promise<FormaPgto> {
    try {
      const response = await api.post('/formas-pgto', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar forma de pagamento:', error);
      throw error;
    }
  }

  // Atualizar forma de pagamento
  async updateForma(id: number, data: Partial<FormaPgto>): Promise<FormaPgto> {
    try {
      const response = await api.put(`/formas-pgto/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar forma de pagamento:', error);
      throw error;
    }
  }

  // Deletar forma de pagamento
  async deleteForma(id: number): Promise<void> {
    try {
      await api.delete(`/formas-pgto/${id}`);
    } catch (error) {
      console.error('Erro ao deletar forma de pagamento:', error);
      throw error;
    }
  }

  // Ativar/Desativar forma de pagamento
  async toggleAtivo(id: number): Promise<FormaPgto> {
    try {
      const response = await api.patch(`/formas-pgto/${id}/toggle-ativo`);
      return response.data;
    } catch (error) {
      console.error('Erro ao alterar status da forma de pagamento:', error);
      throw error;
    }
  }

  // Reordenar formas de pagamento
  async reorderFormas(formas: { id: number; ordem: number }[]): Promise<void> {
    try {
      await api.patch('/formas-pgto/reorder', { formas });
    } catch (error) {
      console.error('Erro ao reordenar formas de pagamento:', error);
      throw error;
    }
  }
}

export default new FormaPgtoService();
